import * as React from "react"
import { useEffect } from "react"

import {
  Box,
  Card,
  CardContent,
  MenuItem,
  Stack,
  Typography,
} from "@mui/material"

import LabeledProgressBar from "./LabeledProgressBar"
import { PRODUCT_SEGMENTATION_FILTERS } from "../../../utils/constants"
import CustomTextField from "../../custom/CustomTextField"

export function GenericSegmentCard({ title, data=[], periodFilter, setPeriodFilter, sx = {} }) {

  useEffect(() => {

  }, [title, data, periodFilter]);

  return (
    <Card sx={{ height: '100%', ...sx }}>
      <CardContent>

        <Stack
          direction="row"
          sx={{
            alignItems: "flex-start",
            justifyContent: "space-between",
            mb: 2
          }}
          spacing={1}
        >
          <Typography sx={{ mb: 1, }} variant="h5" >{title || "Product Segment Performance"}</Typography>

          <CustomTextField
            variant="standard"
            sx={{ minWidth: 120 }}
            select
            labelId="period-select-label"
            value={periodFilter}
            onChange={(e) => { setPeriodFilter(e.target.value) }}
          >
            <MenuItem value="" selected>
              <em>Select Period</em>
            </MenuItem>
            {PRODUCT_SEGMENTATION_FILTERS.map((p) => (
              <MenuItem key={p.key} value={p.key}>
                {p.value}
              </MenuItem>
            ))}
          </CustomTextField>
        </Stack>
        <Box
          direction="column"
          sx={{ alignItems: "flex-start", justifyContent: "space-between" }}
          spacing={3}
        >
          {data?.map((d, index) => (
              <LabeledProgressBar
              key={`labelled-progress-bar-${index}`}
              sx={{ mt: 3 }}
              height={'55px'}
              value={d.value || 0}
              rightBar={d?.rightBar}
              leftBar={d?.leftBar}
              outerLabel={`tank-${index + 1}`}
            />
          ))}
        </Box>
      </CardContent>
    </Card>
  )
}
